function initCPISection(section) {
    if (section.dataset.cpiInitialized) return;
    section.dataset.cpiInitialized = "true";

    // Elements of the main form
    const mainMinusBtn = section.querySelector('.cpi-qty-minus');
    const mainPlusBtn = section.querySelector('.cpi-qty-plus');
    const mainQtyInput = section.querySelector('.cpi-qty-input');
    const mainForm = section.querySelector('.cpi-buy-container');
    const mainAddedState = section.querySelector('.cpi-added-to-cart-state');
    const mainRemoveBtn = section.querySelector('.cpi-remove-btn');

    // Elements of the sticky form
    const stickyBar = section.querySelector('.cpi-sticky-bar');
    const stickyMinusBtn = section.querySelector('.cpi-sticky-qty-minus');
    const stickyPlusBtn = section.querySelector('.cpi-sticky-qty-plus');
    const stickyQtyInput = section.querySelector('.cpi-sticky-qty-input');
    const stickyForm = section.querySelector('.cpi-sticky-buy-container');
    const stickyAddedState = section.querySelector('.cpi-sticky-added-state');
    const stickyRemoveBtn = section.querySelector('.cpi-sticky-remove-btn');

    // Function to sync and update minus button state for both
    const updateMinusState = () => {
      let mainVal = mainQtyInput ? (parseInt(mainQtyInput.value) || 1) : 1;
      
      if (mainMinusBtn) {
        if (mainVal <= 1) {
          mainMinusBtn.classList.add('cpi-qty-disabled');
        } else {
          mainMinusBtn.classList.remove('cpi-qty-disabled');
        }
      }

      if (stickyMinusBtn) {
        if (mainVal <= 1) {
          stickyMinusBtn.classList.add('cpi-qty-disabled');
        } else {
          stickyMinusBtn.classList.remove('cpi-qty-disabled');
        }
      }
    };

    // Helper to update quantity inputs in both places
    const updateQuantity = (newVal) => {
      if (newVal < 1) newVal = 1;
      if (mainQtyInput) mainQtyInput.value = newVal;
      if (stickyQtyInput) stickyQtyInput.value = newVal;
      updateMinusState();
    };

    // Set initial state
    updateMinusState();

    // Main Form Quantity Events
    if (mainMinusBtn && mainQtyInput) {
      mainMinusBtn.addEventListener('click', () => {
        let val = parseInt(mainQtyInput.value) || 1;
        if (val > 1) {
          updateQuantity(val - 1);
        }
      });
    }
    if (mainPlusBtn && mainQtyInput) {
      mainPlusBtn.addEventListener('click', () => {
        let val = parseInt(mainQtyInput.value) || 1;
        updateQuantity(val + 1);
      });
    }
    if (mainQtyInput) {
      mainQtyInput.addEventListener('change', () => {
        let val = parseInt(mainQtyInput.value) || 1;
        updateQuantity(val);
      });
    }

    // Sticky Form Quantity Events
    if (stickyMinusBtn && mainQtyInput) {
      stickyMinusBtn.addEventListener('click', () => {
        let val = parseInt(mainQtyInput.value) || 1;
        if (val > 1) {
          updateQuantity(val - 1);
        }
      });
    }
    if (stickyPlusBtn && mainQtyInput) {
      stickyPlusBtn.addEventListener('click', () => {
        let val = parseInt(mainQtyInput.value) || 1;
        updateQuantity(val + 1);
      });
    }

    // AJAX Submit Function
    const handleCartSubmit = (e, formElement, submitBtnElement) => {
      e.preventDefault();
      
      if (!submitBtnElement) return;
      
      submitBtnElement.style.opacity = '0.5';
      submitBtnElement.disabled = true;

      const formData = new FormData(formElement);
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        submitBtnElement.style.opacity = '1';
        submitBtnElement.disabled = false;
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
        
        if (typeof updateHeaderCartCount === 'function') {
          updateHeaderCartCount();
        }

        // Switch BOTH main form and sticky form to added state
        if (mainAddedState && mainForm) {
          mainForm.style.display = 'none';
          mainAddedState.classList.add('is-active');
          
          const btn = mainAddedState.querySelector('.cpi-remove-btn');
          if (btn && data.items && data.items.length > 0) {
             btn.dataset.key = data.items[0].key;
             btn.dataset.variantId = data.items[0].variant_id;
          } else if (btn && data.key) {
             btn.dataset.key = data.key;
             btn.dataset.variantId = data.variant_id;
          }
        }

        if (stickyAddedState && stickyForm) {
          stickyForm.style.display = 'none';
          stickyAddedState.classList.add('is-active');
          
          const btn = stickyAddedState.querySelector('.cpi-sticky-remove-btn');
          if (btn && data.items && data.items.length > 0) {
             btn.dataset.key = data.items[0].key;
             btn.dataset.variantId = data.items[0].variant_id;
          } else if (btn && data.key) {
             btn.dataset.key = data.key;
             btn.dataset.variantId = data.variant_id;
          }
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        submitBtnElement.style.opacity = '1';
        submitBtnElement.disabled = false;
      });
    };

    // Hook up AJAX submit to both forms
    if (mainForm) {
      mainForm.addEventListener('submit', function(e) {
        const submitBtn = mainForm.querySelector('.cpi-add-to-cart');
        handleCartSubmit(e, mainForm, submitBtn);
      });
    }

    if (stickyForm) {
      stickyForm.addEventListener('submit', function(e) {
        const submitBtn = stickyForm.querySelector('.cpi-sticky-add-to-cart');
        handleCartSubmit(e, stickyForm, submitBtn);
      });
    }

    // Remove from cart function
    const handleCartRemove = (e, buttonElement) => {
      e.preventDefault();
      
      const key = buttonElement.dataset.key;
      const variantId = buttonElement.dataset.variantId;
      
      let updates = {};
      if (key) {
           updates[key] = 0;
      } else if (variantId) {
           updates[variantId] = 0;
      } else {
           const inputId = section.querySelector('input[name="id"]');
           if (inputId) {
              updates[inputId.value] = 0;
           }
      }
      
      buttonElement.style.opacity = '0.5';
      buttonElement.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      })
      .then(response => response.json())
      .then(data => {
        buttonElement.style.opacity = '1';
        buttonElement.disabled = false;
        
        // Revert BOTH forms back to input state
        if (mainAddedState && mainForm) {
          mainAddedState.classList.remove('is-active');
          mainForm.style.display = '';
        }

        if (stickyAddedState && stickyForm) {
          stickyAddedState.classList.remove('is-active');
          stickyForm.style.display = '';
        }
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        
        if (typeof updateHeaderCartCount === 'function') {
           updateHeaderCartCount();
        }
      })
      .catch(error => {
        console.error('Error removing from cart:', error);
        buttonElement.style.opacity = '1';
        buttonElement.disabled = false;
      });
    };

    // Hook up Remove action
    if (mainRemoveBtn) {
      mainRemoveBtn.addEventListener('click', function(e) {
        handleCartRemove(e, mainRemoveBtn);
      });
    }

    if (stickyRemoveBtn) {
      stickyRemoveBtn.addEventListener('click', function(e) {
        handleCartRemove(e, stickyRemoveBtn);
      });
    }

    // Sticky Bar scroll visibility logic
    if (stickyBar) {
      let lastScrollY = window.scrollY;

      const toggleStickyBar = () => {
        const currentScrollY = window.scrollY;
        
        if (currentScrollY < 0) return;

        if (mainForm) {
          const mainFormRect = mainForm.getBoundingClientRect();
          // If the bottom of the main form has scrolled past the top of the viewport
          if (mainFormRect.bottom < 0) {
            if (currentScrollY > lastScrollY) {
              // Scrolling down
              stickyBar.classList.add('is-visible');
            } else if (currentScrollY < lastScrollY) {
              // Scrolling up
              stickyBar.classList.remove('is-visible');
            }
          } else {
            stickyBar.classList.remove('is-visible');
          }
        } else {
          if (currentScrollY > 300) {
            if (currentScrollY > lastScrollY) {
              stickyBar.classList.add('is-visible');
            } else if (currentScrollY < lastScrollY) {
              stickyBar.classList.remove('is-visible');
            }
          } else {
            stickyBar.classList.remove('is-visible');
          }
        }
        lastScrollY = currentScrollY;
      };

      window.addEventListener('scroll', toggleStickyBar, { passive: true });
      window.addEventListener('resize', toggleStickyBar, { passive: true });
      toggleStickyBar();
    }
  }

  // Run immediately for normal load
  document.querySelectorAll('.cpi-section').forEach(initCPISection);

  // Run on DOMContentLoaded as fallback
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cpi-section').forEach(initCPISection);
  });

  // Run on Shopify theme editor section load event
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.cpi-section');
    if (section) {
      initCPISection(section);
    }
  });
